// utils/phone.ts
import {
  parsePhoneNumberFromString,
  type CountryCode,
} from "libphonenumber-js";

const DEFAULT_COUNTRY: CountryCode = "ZW"; // used only when the number has no country code of its own

export const formatPhoneForWhatsApp = (
  phone?: string | null,
  defaultCountry: CountryCode = DEFAULT_COUNTRY,
): string => {
  if (!phone) return "";

  const digits = phone.replace(/[^\d]/g, "");
  if (!digits) return "";

  // Try it as a full international number first — this covers numbers
  // that are already normalized/stored with their country code but
  // without a leading "+" (e.g. "263772361103"), which libphonenumber
  // would otherwise misread as an invalid 12-digit Zimbabwean *national*
  // number instead of "263" (country code) + "772361103" (subscriber).
  const asInternational = parsePhoneNumberFromString(`+${digits}`);
  if (asInternational?.isValid()) {
    return asInternational.number.replace("+", "");
  }

  // Fall back to treating it as a local/national number for defaultCountry
  // (e.g. "0772234399").
  const asNational = parsePhoneNumberFromString(digits, defaultCountry);
  if (asNational?.isValid()) {
    return asNational.number.replace("+", "");
  }

  return "";
};

export const isValidPhoneForWhatsApp = (
  phone?: string | null,
  defaultCountry: CountryCode = DEFAULT_COUNTRY,
): boolean => !!formatPhoneForWhatsApp(phone, defaultCountry);
